/**
* @ComponentFor Avensia.Shop.Features.Search.Blocks.QuickSearchMarketingAdBlock
*/
import React from "react";
import * as styles from "./autocomplete.scss";
import MyMenigoIcon from "../../../../../MyMenigo/Shared/MyMenigoIcon/MyMenigoIcon";
import { epiPropertyValue } from "@avensia/nitro5-scope-episerver";
import Image, { urlWithSizeEx } from "Shared/ImageFallback";
import { SMALL } from "Shared/breakpoints";
import ViewTracker, { onClick } from "./MarketingAdViewTracker";
const limitTextLength = (text, length) => {
    return text.length > length ? text.substring(0, length) + "..." : text;
};
const imageUrl = (url) => {
    return urlWithSizeEx(url, "marketingAd", "crop");
};
export default (props) => (React.createElement(ViewTracker, { item: props.item },
    React.createElement("div", { className: styles.marketingAd },
        !!props.item.image && (React.createElement("div", { className: styles.left, style: {
                backgroundImage: `url(${imageUrl(epiPropertyValue(props.item.image).url)})`,
            } },
            React.createElement(Image, { preferSmallerIfCached: true, minSizeIfCached: "tiny", skipSrcSet: true, alt: epiPropertyValue(props.item.header), src: urlWithSizeEx(epiPropertyValue(props.item.image).url, "marketingAd", "crop") }))),
        React.createElement("div", { className: styles.right },
            !!props.item.header && React.createElement("h3", null, epiPropertyValue(props.item.header)),
            !!props.item.text && (React.createElement("p", null, !!(props.currentBreakpoint <= SMALL)
                ? limitTextLength(epiPropertyValue(props.item.text), 150)
                : epiPropertyValue(props.item.text))),
            !!props.item.link && (React.createElement("a", { href: epiPropertyValue(props.item.link).url, onClick: (e) => onClick(e, props.item), "data-may-prevent-default": true, className: styles.button },
                epiPropertyValue(props.item.marketingAdButtonText),
                " ",
                React.createElement(MyMenigoIcon, { name: "arrow" })))))));
